import React, { useState, useEffect } from 'react';
import ControlPointOutlinedIcon from '@material-ui/icons/ControlPointOutlined';
import Styles from '../companyDetails.module.css';
import MoreHorizOutlinedIcon from '@material-ui/icons/MoreHorizOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteForeverRoundedIcon from '@material-ui/icons/DeleteForeverRounded';
import { getBusinessDirectorList } from '../../../../common/constants/api';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import PopUp from '../../../../common/components/PopUp/PopUp';
import * as _ from 'lodash';
import moment from 'moment';
const { directorList, addressMinWidth, directorContainer, container } = Styles;

const DirectorLists = ({ setActionOnDirectorPage }) => {
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);
  const [Directors, setDirectors] = useState([]);

  useEffect(() => {
    setType('loading');
    setText('Loading Please Wait..');
    setShow(true);
    getBusinessDirectorList(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId
    )
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        setShow(false);
        setDirectors(res);
      })
      .catch(error => {
        setType('fail');
        setText(_.get(error, 'response.data.message', 'something went wrong'));
        setShow(true);
      });
  }, []);

  return (
    <div className="w-12/12 mr-auto px-6 my-1">
      <div className="w-full flex">
        <div className="font-roboto font-medium text-base text-black-850 mr-auto">
          List of Directors
        </div>
        <div
          className="float-right"
          onClick={e => setActionOnDirectorPage('addDir')}
        >
          <button className="rounded bg-orange-650 font-roboto font-normal bg-opacity-50 text-center px-4 py-2 flex text-orange-600 text-sm items-center">
            <ControlPointOutlinedIcon
              style={{
                color: '#FF8000',
                fontSize: '15px',
                marginLeft: '3px',
                marginRight: '3px'
              }}
            />{' '}
            Add Director
          </button>
        </div>
      </div>
      <div className="w-full overflow-auto my-5 flex flex-wrap">
        {Directors.map((each, index) => (
          <DirectorData data={each} key={index} />
        ))}
        {Directors.length == 0 ? (
          <div className="font-roboto font-normal text-base text-black-500 text-center">
            No Directors Available! Please Add Directors
          </div>
        ) : null}
      </div>
      <button
        type="submit"
        className="submitButton fonåt-roboto text-white text-base w-48 "
      >
        NEXT
      </button>

      <PopUp type={type} text={text} setShow={setShow} show={show} />
    </div>
  );
};
export default DirectorLists;

const DirectorData = ({ data }) => {
  const [showMore, setMore] = useState(false);
  const dagtaContainer = 'md:w-3/12 md:block w-full flex my-1';
  const labelField =
    'font-roboto font-nomal text-sm text-grey-1003 text-left w-7/12 md:w-full';
  const DataFiled =
    'font-roboto font-medium text-sm  text-black-400 text-left w-5/12 md:w-full';
  return (
    <div
      className={` bg-orange-200 pl-1 rounded my-3   mx-1 lg:w-5/12 ${container}`}
    >
      <div className="w-full md:bg-navy-700 bg-white px-3 py-5 h-full ">
        <div className="w-full my-6 md:my-3">
          <div className="flex flex-wrap">
            <div className={`${dagtaContainer} ${directorList}`}>
              <p className={`${labelField}`}>Full Name</p>
              <p className={`${DataFiled}`}>
                <span className="md:hidden mx-1">:</span>
                {_.get(data, 'fullName', false)
                  ? _.get(data, 'fullName', '---')
                  : '---'}
              </p>
            </div>
            <div className={`${dagtaContainer} ${directorList}`}>
              <p className={`${labelField}`}>DIN Number</p>
              <p className={`${DataFiled}`}>
                <span className="md:hidden mx-1">:</span>{' '}
                {_.get(data, 'din', false) ? _.get(data, 'din', '---') : '---'}
              </p>
            </div>{' '}
            <div className={`${dagtaContainer} ${directorList}`}>
              <p className={`${labelField}`}>Designation</p>
              <p className={`${DataFiled}`}>
                <span className="md:hidden mx-1">:</span>{' '}
                {_.get(data, 'designation', false)
                  ? _.get(data, 'designation', '---')
                  : '---'}
              </p>
            </div>{' '}
            <div className={`${dagtaContainer} ${directorList}`}>
              <p className={`${labelField}`}>DSC registered</p>
              <p className={`${DataFiled}`}>
                <span className="md:hidden mx-1">:</span>{' '}
                {_.get(data, 'dscRegistered', false) ? 'yes' : 'No'}
              </p>
            </div>{' '}
            <div className={`${dagtaContainer} ${directorList}`}>
              <p className={`${labelField}`}>Date of Appointment</p>
              <p className={`${DataFiled}`}>
                <span className="md:hidden mx-1">:</span>
                {_.get(data, 'appointmentDate', '---')
                  ? _.get(data, 'appointmentDate', '---')
                  : '---'}
              </p>
            </div>{' '}
          </div>
        </div>
      </div>
    </div>
  );
};
